import { createContext, useContext } from "react";

export type ToastTone = "info" | "error";

export interface ToastMessage {
  id: number;
  message: string;
  tone: ToastTone;
}

export interface ToastState {
  toasts: ToastMessage[];
  /** Show a message. Errors stay until dismissed; info messages fade. */
  show: (message: string, tone?: ToastTone) => void;
  dismiss: (id: number) => void;
}

export const ToastContext = createContext<ToastState | null>(null);

export function useToast(): ToastState {
  const value = useContext(ToastContext);
  if (value === null) {
    throw new Error("useToast must be used inside <ToastProvider>");
  }
  return value;
}
